import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';

import { getAllDetails, getAllDetailsDirect } from '../../../service/ProductService';
import { APP_STATES, HOSPITAL } from '../../../config/ApiConstant';
import { SkeletonbodyTemplate, Skeletonitems, defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries } from '../../../appconfig/Settings';
import { AllHospitalColumnsList } from '../../../appconfig/DatatableSetting';

import { Dropdown } from 'primereact/dropdown';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const AllHospitalList = () => {
    document.title = 'Hospital List | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [applications, setApplications] = useState<any>([]);

    const [selectedStateId, setSelectStateId] = useState<any>(null);

    const [errors, setErrors] = useState<any>({});
    //state
    const [statesList, setStatesList] = useState<any>([]);

    // useEffect
    useEffect(() => {
        getStates();
        getAllHospitalList();
    }, []);

    // useEffect
    useEffect(() => {
        getAllHospitalList();
    }, [selectedStateId]);

    // Get States
    const getStates = async () => {
        try {
            const response = await getAllDetailsDirect(APP_STATES);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setStatesList([]);
                } else {
                    let stateData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const stateObj: any = {};
                        stateObj['name'] = DataList[i].name;
                        stateObj['code'] = DataList[i].id;
                        stateData.push(stateObj);
                    }
                    setStatesList(stateData);
                }
            } else {
                setStatesList([]);
            }
        } catch (error: any) {
            setStatesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-3"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                <div className="input-effect-div ml-3">
                    <Dropdown value={selectedStateId} name="boardState" options={statesList} filter optionLabel="name" placeholder="Select State" onChange={(e) => setSelectStateId(e.value)} className={errors['boardState'] && 'p-invalid'} />
                </div>
            </>
        );
    };

    // Get applications list
    const getAllHospitalList = async () => {
        try {
            setPageLoad(false);
            let state = !window.cn(selectedStateId?.name) ? selectedStateId?.name : '';
            const response = await getAllDetailsDirect(HOSPITAL +'?StateName=' + state );

            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setApplications([]);
                } else {
                    setApplications(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(true);
                setApplications([]);
            }
        } catch (error: any) {
            setPageLoad(true);
            setApplications([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    return (
        <>
            {/* <MasterTab index={4} /> */}
            <AppBreadcrumb currentMenu={'Master'} pageName={'Hospital List'} pageTitle={'Hospital List'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={applications}
                                    showGridlines
                                    stripedRows
                                    className="datatable-responsive"
                                    emptyMessage="No Data Found"
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={applications.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {AllHospitalColumnsList.map((col, i) => {
                                        if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AllHospitalColumnsList.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
